import { Box, Button, Typography } from 'components'
import { ONBOARD_SKIP_VALIDATION } from '../../../constants'
import { useContent } from 'utils'

export const ProgressBarFooter = (props) => {
  const { landing } = useContent() || {}
  const buttonColor = landing?.['onboarding-button-color'] || 'primary'
  const buttonSecondaryColor = landing?.['onboarding-button-secondary'] || '#6c757d'
  
  return (
    <Box
      bgcolor="secondary.main"
      position="fixed"
      bottom={{ xs: 50, sm: 0 }}
      left={0}
      right={0}
      zIndex={99}
    >
      <Box flex={1} flexVariant="flex column justify-end">
        <Box flexDirection="column">
          <Box
            height="2px"
            width={props.stepIndex * (100 / props.numSteps) + '%'}
            bgcolor={process.env.REACT_APP_PRIMARY_COLOR}
          />
          <Box flexVariant="flex center" py={2.5} borderTop="1px solid #DDDDDD">
            <Button
              disabled={!props.alwaysShowNav && props.stepIndex === props.firstStep}
              style={{ 
                opacity: (!props.alwaysShowNav && props.stepIndex === props.firstStep) ? 0.5 : 1,
                'background-color': buttonSecondaryColor,
                color: 'white'
              }}
              onClick={props.onPrev}
              variant="contained"
            >
              Previous
            </Button>
            <Box mx={3.5} />
            <Typography>
              {props.stepIndex} of {props.numSteps}
            </Typography>
            <Box mx={3.5} />
            <Button
              disabled={!ONBOARD_SKIP_VALIDATION && !props.valid}
              onClick={props.onNext}
              variant="contained"
              style={{ 'background-color': buttonColor }}
            >
              Next
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}